import { PlainTooltip } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

import type SignalFilters from "../../../../models/core/SignalFilters";
import type UISignal from "../../../../models/view/UISignal";
import type { SignalViewProps } from "../Signal";
import { StyledButton, StyledHiddenButtonsWrapper, StyledButtonWrap, StyledSignalView } from "./styles";

type Props = SignalViewProps & {
    onDeleteClick(uiSignal: Readonly<UISignal<SignalFilters>>): void;
    onEditClick(uiSignal: Readonly<UISignal<SignalFilters>>): void;
};

const SignalWithActionsView = (props: Props) => {
    const { onDeleteClick, onEditClick, ...rest } = props;

    function handleDeleteClick(event: MouseEvent) {
        event.stopPropagation();
        onDeleteClick(rest.uiSignal);
    }

    function handleEditClick(event: MouseEvent) {
        event.stopPropagation();
        onEditClick(rest.uiSignal);
    }

    return (
        <StyledSignalView {...rest}>
            <StyledHiddenButtonsWrapper alignItems="center">
                <PlainTooltip tooltipContent={translate("si.signals.button.delete.tooltip")}>
                    <StyledButtonWrap>
                        <StyledButton
                            dataAutomation="delete-button"
                            iconName="delete"
                            iconSize="xs"
                            type="flat"
                            onClick={handleDeleteClick}
                        />
                    </StyledButtonWrap>
                </PlainTooltip>
                <PlainTooltip tooltipContent={translate("si.signals.button.edit.tooltip")}>
                    <StyledButtonWrap>
                        <StyledButton
                            dataAutomation="edit-button"
                            iconName="edit-icon"
                            iconSize="xs"
                            type="flat"
                            onClick={handleEditClick}
                        />
                    </StyledButtonWrap>
                </PlainTooltip>
            </StyledHiddenButtonsWrapper>
        </StyledSignalView>
    );
}

export default SignalWithActionsView;
